import { timeOfDayLabelBySegment } from '../config/detailedForecast.config';

export const getTimeOfDayLabel = (forecast) => {
  return forecast?.day_segment || timeOfDayLabelBySegment[forecast?.segment] || '';
};

export const getForecastForDay = (forecast = [], selectedDay) => {
  return forecast.filter((forecastItem) => forecastItem.weekday === selectedDay);
};

/**
 * Returns one forecast item for each time of day.
 *
 * Each time of day contains the LAST forecast item in the array that matches it.
 * Earlier matching items are intentionally overwritten.
 *
 * If no forecast item matches a time of day, that value remains `null`.
 *
 * @param {Array} forecast - Forecast items to categorize by time of day.
 * @returns {{
 *   morning: Object|null,
 *   afternoon: Object|null,
 *   evening: Object|null,
 *   night: Object|null
 * }} The last matching forecast item for morning, afternoon, evening, and night.
 */
export const getForecastByTimeOfDay = (forecast = []) => {
  return forecast.reduce(
    (previousTimesOfDay, forecastItem) => {
      const timeOfDay = getTimeOfDayLabel(forecastItem);

      if (timeOfDay === 'Morning') previousTimesOfDay.morning = forecastItem;
      if (timeOfDay === 'Afternoon') previousTimesOfDay.afternoon = forecastItem;
      if (timeOfDay === 'Evening') previousTimesOfDay.evening = forecastItem;
      if (timeOfDay === 'Night') previousTimesOfDay.night = forecastItem;

      return previousTimesOfDay;
    },
    {
      morning: null,
      afternoon: null,
      evening: null,
      night: null,
    },
  );
};

export const getTimeOfDaySections = (timeOfDayForecast) => {
  return [
    ['Morning', timeOfDayForecast.morning],
    ['Afternoon', timeOfDayForecast.afternoon],
    ['Evening', timeOfDayForecast.evening],
    ['Night', timeOfDayForecast.night],
  ];
};
